module.exports = __webpack_public_path__ + "static/media/sch.b40e6696.png";